import { jsx as s } from "react/jsx-runtime";
import { c as n } from "../../clsx-OuTLNxxd.js";
import '../../assets/Typography.css';const t = ({
  children: e,
  variant: _ = "",
  className: m = "text-text-primary",
  noVariant: l = !1,
  component: c = "p",
  ...a
}) => {
  const h = n({ [_]: !l }, m);
  return (() => {
    switch (_) {
      case "headline_h1_bold":
        return /* @__PURE__ */ s("h1", { className: h, ...a, children: e });
      case "headline_h1_semi":
      case "headline_h1_medi":
        return /* @__PURE__ */ s("h1", { className: h, ...a, children: e });
      case "headline_h2_bold":
        return /* @__PURE__ */ s("h2", { className: h, ...a, children: e });
      case "headline_h2_semi":
      case "headline_h2_medi":
        return /* @__PURE__ */ s("h2", { className: h, ...a, children: e });
      case "headline_h3_bold":
        return /* @__PURE__ */ s("h3", { className: h, ...a, children: e });
      case "headline_h3_semi":
      case "headline_h3_medi":
        return /* @__PURE__ */ s("h3", { className: h, ...a, children: e });
      case "headline_h4_bold":
        return /* @__PURE__ */ s("h4", { className: h, ...a, children: e });
      case "headline_h4_semi":
      case "headline_h4_medi":
        return /* @__PURE__ */ s("h4", { className: h, ...a, children: e });
      case "headline_h5_bold":
        return /* @__PURE__ */ s("h5", { className: h, ...a, children: e });
      case "headline_h5_semi":
      case "headline_h5_medi":
        return /* @__PURE__ */ s("h5", { className: h, ...a, children: e });
      case "headline_h6_semi":
      case "headline_h6_medi":
        return /* @__PURE__ */ s("h6", { className: h, ...a, children: e });
      case "headline_h6_bold":
        return /* @__PURE__ */ s("h6", { className: h, ...a, children: e });
      default:
        return /* @__PURE__ */ s(c, { className: h, ...a, children: e });
    }
  })();
};
export {
  t as Typography
};
